var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.16602 13.2118H3.33268C2.89065 13.2118 2.46673 13.0362 2.15417 12.7236C1.84161 12.411 1.66602 11.9871 1.66602 11.5451V4.04508C1.66602 3.60306 1.84161 3.17913 2.15417 2.86657C2.46673 2.55401 2.89065 2.37842 3.33268 2.37842H10.8327C11.2747 2.37842 11.6986 2.55401 12.0112 2.86657C12.3238 3.17913 12.4993 3.60306 12.4993 4.04508V4.87842M9.16602 8.21175H16.666C17.5865 8.21175 18.3327 8.95794 18.3327 9.87842V17.3784C18.3327 18.2989 17.5865 19.0451 16.666 19.0451H9.16602C8.24554 19.0451 7.49935 18.2989 7.49935 17.3784V9.87842C7.49935 8.95794 8.24554 8.21175 9.16602 8.21175Z",
    stroke: "#07CC94",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCopy);
export default __webpack_public_path__ + "static/media/new-copy.05231c7c51a0c39183fe98c03cbc3ddb.svg";
export { ForwardRef as ReactComponent };